import { RemoteObject } from './remote-object.model';

// tslint:disable:variable-name
export class SPHCompany extends RemoteObject {
    public static fromJSON(json: any): SPHCompany {
        const company = new SPHCompany();

        Object.getOwnPropertyNames(company).forEach( (propertyName) => {

            if (
                propertyName === 'ip_lastmodified' && json[propertyName] !== null) {
                company[propertyName] = new Date(json[propertyName]);
            } else {
                company[propertyName] = json[propertyName];
            }

        });

        company.remoteObjectCommonsFromJSON(json);

        return company;
    }
    public email?: string = undefined;
    public name?: string = undefined;
    public location: string = undefined;
    public identnr: string = undefined;
    public identnr_hash: string = undefined;
    public status: string = undefined;
    public pre_license_text: string = undefined;
    public post_license_text: string = undefined;
    public license_nr: string = undefined;
    public ip?: string = undefined;
    public ip_lastmodified?: Date = undefined;

    public licensescount?: { open: number, locked: number, assigned: number } = undefined;

    constructor() { super(); }

    public toJSON(): any {
        const json = {};
        this.remoteObjectCommonsToJson(json);
        Object.getOwnPropertyNames(this).forEach( (propertyName) => {
            json[propertyName] = this[propertyName];
        });
        return json;
    }
}



// WEBPACK FOOTER //
// ./src/app/features/shared/model/sph-company.model.ts